import React from "react";
import t from "./typography.module.css";
import cn from "classnames";

const PageTitle = ({ children, className }) => {
  return <h1 className={cn(t.pageTitle, className)}>{children}</h1>;
};

export default PageTitle;
